import { Buffer } from 'buffer';

// Mock require function for Node.js modules
const mockRequire = (moduleName) => {
  if (moduleName === 'stream') {
    return {
      Readable: class Readable {
        constructor(options = {}) {
          this.readable = true;
          this._readableState = {
            reading: false,
            ended: false,
            length: 0,
            ...options
          };
          this.destroyed = false;
        }
        read(size) { return null; }
        setEncoding(encoding) {}
        pause() { return this; }
        resume() { return this; }
        isPaused() { return false; }
        destroy(error) { this.destroyed = true; }
        on(event, listener) { return this; }
        once(event, listener) { return this; }
        emit(event, ...args) {}
        pipe(destination) { return destination; }
        _read(size) {}
      },
      Writable: class Writable {
        constructor(options = {}) {
          this.writable = true;
          this.destroyed = false;
        }
        write(chunk, encoding, callback) {
          if (callback) callback();
          return true;
        }
        end(chunk, encoding, callback) {
          if (callback) callback();
        }
        destroy(error) { this.destroyed = true; }
        on(event, listener) { return this; }
        once(event, listener) { return this; }
        emit(event, ...args) {}
        _write(chunk, encoding, callback) { if (callback) callback(); }
      },
      Duplex: class Duplex {
        constructor(options = {}) {
          this.readable = true;
          this.writable = true;
          this._readableState = {
            reading: false,
            ended: false,
            length: 0,
            ...options
          };
          this.destroyed = false;
        }
        read(size) { return null; }
        write(chunk, encoding, callback) {
          if (callback) callback();
          return true;
        }
        end(chunk, encoding, callback) {
          if (callback) callback();
        }
        setEncoding(encoding) {}
        pause() { return this; }
        resume() { return this; }
        isPaused() { return false; }
        destroy(error) { this.destroyed = true; }
        on(event, listener) { return this; }
        once(event, listener) { return this; }
        emit(event, ...args) {}
        pipe(destination) { return destination; }
        _read(size) {}
        _write(chunk, encoding, callback) { if (callback) callback(); }
      },
      Transform: class Transform {
        constructor(options = {}) {
          this.readable = true;
          this.writable = true;
          this._readableState = {
            reading: false,
            ended: false,
            length: 0,
            ...options
          };
          this.destroyed = false;
        }
        read(size) { return null; }
        write(chunk, encoding, callback) {
          if (callback) callback();
          return true;
        }
        end(chunk, encoding, callback) {
          if (callback) callback();
        }
        setEncoding(encoding) {}
        pause() { return this; }
        resume() { return this; }
        isPaused() { return false; }
        destroy(error) { this.destroyed = true; }
        on(event, listener) { return this; }
        once(event, listener) { return this; }
        emit(event, ...args) {}
        pipe(destination) { return destination; }
        _read(size) {}
        _write(chunk, encoding, callback) { if (callback) callback(); }
        _transform(chunk, encoding, callback) { callback(); }
      }
    };
  }
  if (moduleName === 'buffer') {
    return { Buffer };
  }
  if (moduleName === 'process') {
    return {
      env: {},
      version: '',
      nextTick: (fn) => setTimeout(fn, 0),
      browser: true,
      cwd: () => '/',
      platform: 'browser'
    };
  }
  if (moduleName === 'net') {
    return {
      createConnection: () => {
        throw new Error('net.createConnection is not available in browser environment. Use WebSocket transport for MQTT.');
      }
    };
  }
  throw new Error(`Module '${moduleName}' not found`);
};

if (typeof window !== 'undefined') {
  window.Buffer = Buffer;
  window.global = window;
  window.require = window.require || mockRequire;

  // Polyfill process for Node.js modules
  window.process = window.process || {
    env: {},
    version: '',
    nextTick: (fn) => setTimeout(fn, 0),
    browser: true,
    cwd: () => '/',
    platform: 'browser'
  };

  // Polyfill net module for MQTT
  window.net = window.net || {
    createConnection: () => {
      throw new Error('net.createConnection is not available in browser environment. Use WebSocket transport for MQTT.');
    }
  };

  // Polyfill stream module for MQTT
  window.stream = window.stream || mockRequire('stream');
}

// eslint-disable-next-line no-undef
if (typeof globalThis !== 'undefined') {
  // eslint-disable-next-line no-undef
  globalThis.Buffer = Buffer;
  // eslint-disable-next-line no-undef
  globalThis.require = globalThis.require || mockRequire;
  // eslint-disable-next-line no-undef
  globalThis.process = globalThis.process || {
    env: {},
    version: '',
    nextTick: (fn) => setTimeout(fn, 0),
    browser: true,
    cwd: () => '/',
    platform: 'browser'
  };
  // eslint-disable-next-line no-undef
  globalThis.net = globalThis.net || {
    createConnection: () => {
      throw new Error('net.createConnection is not available in browser environment. Use WebSocket transport for MQTT.');
    }
  };
  // eslint-disable-next-line no-undef
  globalThis.stream = globalThis.stream || mockRequire('stream');
}

if (typeof global !== 'undefined') {
  global.Buffer = Buffer;
  global.require = global.require || mockRequire;
  global.process = global.process || {
    env: {},
    version: '',
    nextTick: (fn) => setTimeout(fn, 0),
    browser: true,
    cwd: () => '/',
    platform: 'browser'
  };
  global.net = global.net || {
    createConnection: () => {
      throw new Error('net.createConnection is not available in browser environment. Use WebSocket transport for MQTT.');
    }
  };
  global.stream = global.stream || mockRequire('stream');
}
